import React from "react";
import { FormProvider } from "react-hook-form";
import { Alert, Box, Stack } from "@mui/material";
import UserSelect from "./UserSelect";
import RoleSelect from "./RoleSelect";
import FormActions from "./FormActions";
import { RHFCheckbox } from "../../../../../components/RFH";
import Avatar from "../../../../../components/Avatar";
import { hasImage } from "../../../../../utils";
import { useBoardUserForm } from "./hooks/useBoardUserForm";

function Form({
  onClose,
  boardUsers,
  isMobile,
  isColabrotar,
  handleAddColabrotor,
  setOpen,
  collaboratorOptions = [],
  currentUser,
  isUpdateUser,
}) {
  const {
    apiError,
    currentUserProfile,
    handleSubmit,
    isSelectedRole,
    loading,
    methods,
    newBoardUser,
    roles,
    setIsSelectedRole,
    submit,
    updatedUserOptions,
  } = useBoardUserForm({
    onClose,
    boardUsers,
    isColabrotar,
    handleAddColabrotor,
    setOpen,
    collaboratorOptions,
    currentUser,
    isUpdateUser,
  });

  return (
    <FormProvider {...methods}>
      <Box
        component="form"
        onSubmit={handleSubmit(submit)}
        noValidate
        sx={{ padding: isMobile ? "8px 5px !important" : "0px" }}
        className="add-board-user-form"
      >
        <Stack spacing={3}>
          {apiError && <Alert severity="error">{apiError}</Alert>}

          {isUpdateUser ? (
            <div className="user-permission-head">
              <Avatar
                title={`${currentUserProfile?.username || ""}`}
                user_image={currentUserProfile?.user_image}
                className="user-avatar"
                style={
                  !hasImage(currentUserProfile?.user_image) && {
                    bgcolor: currentUserProfile?.profile_color?.background,
                    color: currentUserProfile?.profile_color?.text,
                  }
                }
              >
                {currentUserProfile?.username}
              </Avatar>
              <p className="size-16 font-bold">
                {currentUserProfile?.username}
              </p>
            </div>
          ) : (
            <UserSelect
              isColabrotar={isColabrotar}
              newBoardUser={newBoardUser}
              updatedUserOptions={updatedUserOptions}
             
            />
          )}

          {!isColabrotar && (
            <>
             {(!isUpdateUser || currentUser) && <RoleSelect
                isMobile={isMobile}
                isColabrotar={isColabrotar}
                roles={roles}
                onRoleChange={setIsSelectedRole}
                selectedRole={isSelectedRole}
              />}

              <p className="size-18 weight-600 text-color border-bottom pb-2">
                Permission
              </p>
              <p className="weight-600 size-15 mb-2">My Tasks</p>
              <div className="d-flex w-100 justify-content-space-between flex-wrap">
                <RHFCheckbox
                  name={"can_create_task"}
                  label={"Create"}
                  className={"checkbox-permission"}
                  disabled={isSelectedRole == "Board Admin"}
                />
                <RHFCheckbox
                  name={"can_edit_task"}
                  label={"Edit"}
                  className={"checkbox-permission"}
                  disabled={isSelectedRole == "Board Admin"}
                />
                <RHFCheckbox
                  name={"can_delete_card"}
                  label={"Delete"}
                  className={"checkbox-permission"}
                  disabled={isSelectedRole == "Board Admin"}
                />
                <RHFCheckbox
                  name={"can_reassign_user"}
                  label={"Reassign tasks assigned to others"}
                  className={"checkbox-permission"}
                  disabled={isSelectedRole == "Board Admin"}
                />
                <RHFCheckbox
                  name={"can_work_before_estimation"}
                  label={"Start work before estimation"}
                  className={"checkbox-permission"}
                  disabled={isSelectedRole == "Board Admin"}
                />
                <RHFCheckbox
                  name={"can_update_status"}
                  label={"Update Status"}
                  className={"checkbox-permission"}
                  disabled={isSelectedRole == "Board Admin"}
                />
              </div>

              <p className="weight-600 size-15 mb-2">Worklogs</p>
              <div className="d-flex w-100 justify-content-space-between flex-wrap">
                <RHFCheckbox
                  name={"can_add_work_log"}
                  label={"Add"}
                  className={"checkbox-permission"}
                  disabled={isSelectedRole == "Board Admin"}
                />
                <RHFCheckbox
                  name={"can_edit_work_log"}
                  label={"Edit"}
                  className={"checkbox-permission"}
                  disabled={isSelectedRole == "Board Admin"}
                />
                <RHFCheckbox
                  name={"can_delete_work_log"}
                  label={"Delete"}
                  className={"checkbox-permission"}
                  disabled={isSelectedRole == "Board Admin"}
                />
                <RHFCheckbox
                  name={"can_move_edit_work_log"}
                  label={"Move to a different ticket"}
                  className={"checkbox-permission"}
                  disabled={isSelectedRole == "Board Admin"}
                />
              </div>

              {/* <p className="weight-600 size-15">Others</p>
              <div className="d-flex w-50">
                <RHFCheckbox
                  name={"can_add_user"}
                  label={"Add User"}
                  disabled={true}
                />
                <RHFCheckbox
                  name={"can_change_milestone"}
                  label={"Milestones"}
                  disabled={true}
                />
              </div> */}
            </>
          )}

          <FormActions
            loading={loading}
            isUpdateUser={isUpdateUser}
            onClose={onClose}
          />
        </Stack>
      </Box>
    </FormProvider>
  );
}

export default Form;
